import styled from "styled-components";
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";

const StandardToastMessageDefaultBox = styled.div`
    ${({theme}) => theme.font.presets.regular};
    margin-bottom: 8px;
    &:last-child {
        margin-bottom: 0px;
    }
`;

const StandardToastMessageMrGreenBox = styled(StandardToastMessageDefaultBox)`
    font-weight: 600;
`;

export const StandardToastMessageBox = styledByTheme(StandardToastMessageDefaultBox)
    .forMrGreen(StandardToastMessageMrGreenBox)
    .forMrGreenCis(StandardToastMessageMrGreenBox)
    .apply();
